<template>
  <div class="lp-page resources-page">
    <Navbar />

    <!-- Hero -->
    <section class="lp-hero">
      <div class="lp-container">
        <span class="lp-eyebrow">{{ $t('resources.heroLabel') }}</span>
        <h1 class="lp-title">{{ $t('resources.heroTitle') }}</h1>
        <p class="lp-lead">{{ $t('resources.heroSubtitle') }}</p>
      </div>
    </section>

    <!-- Resources grid -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-grid lp-grid-3">
          <a href="/docs/api" class="lp-card res-card">
            <span class="lp-ico blue"><font-awesome-icon icon="fa-solid fa-book" /></span>
            <h3 class="lp-h3">{{ $t('resources.documentationTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.documentationDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
          <a href="/docs/api" class="lp-card res-card">
            <span class="lp-ico violet"><font-awesome-icon icon="fa-solid fa-code" /></span>
            <h3 class="lp-h3">{{ $t('resources.apiTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.apiDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
          <a href="/guides" class="lp-card res-card">
            <span class="lp-ico green"><font-awesome-icon icon="fa-solid fa-graduation-cap" /></span>
            <h3 class="lp-h3">{{ $t('resources.guidesTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.guidesDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
          <a href="/blog" class="lp-card res-card">
            <span class="lp-ico amber"><font-awesome-icon icon="fa-solid fa-newspaper" /></span>
            <h3 class="lp-h3">{{ $t('resources.blogTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.blogDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
          <a href="/contact" class="lp-card res-card">
            <span class="lp-ico cyan"><font-awesome-icon icon="fa-solid fa-headset" /></span>
            <h3 class="lp-h3">{{ $t('resources.supportTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.supportDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
          <a href="/community" class="lp-card res-card">
            <span class="lp-ico pink"><font-awesome-icon icon="fa-solid fa-users" /></span>
            <h3 class="lp-h3">{{ $t('resources.communityTitle') }}</h3>
            <p class="lp-text">{{ $t('resources.communityDescription') }}</p>
            <span class="res-link">{{ $t('resources.learnMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></span>
          </a>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-cta">
          <h2>{{ $t('resources.ctaTitle') }}</h2>
          <p>{{ $t('resources.ctaSubtitle') }}</p>
          <div class="cta-buttons">
            <a href="/auth/google" class="lp-btn lp-btn-primary">{{ $t('resources.getStarted') }}</a>
            <a href="/contact" class="lp-btn lp-btn-secondary cta-secondary">{{ $t('resources.contactUs') }}</a>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import { useReveal } from '../composables/useReveal';

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'instant' });
});

useReveal();
</script>

<style scoped>
.res-card { display: flex; flex-direction: column; text-decoration: none; }
.res-card .lp-h3 { margin-bottom: 8px; }
.res-card .lp-text { flex: 1; margin-bottom: 18px; }
.res-link { display: inline-flex; align-items: center; gap: 8px; color: var(--violet); font-weight: 600; font-size: 14.5px; transition: gap 0.2s ease; }
.res-card:hover .res-link { gap: 12px; }

.cta-buttons { display: inline-flex; gap: 14px; flex-wrap: wrap; justify-content: center; }
.cta-secondary { background: rgba(255,255,255,0.1); color: #fff; border-color: rgba(255,255,255,0.25); }
.cta-secondary:hover { background: rgba(255,255,255,0.18); color: #fff; border-color: rgba(255,255,255,0.4); }
</style>
